export enum EPaymentGeneratorStatus {
  Selected = 'Selected',
  Computed = 'Computed',
  Assigned = 'Assigned',
  EmailSent = 'EmailSent',
  Posted = 'Posted',
}
